import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';

const WomensHealth = () => {
  const serviceData = {
    title: "Women's Health",
    image: "/womenhealth.png",
    description: "Our women's health physiotherapy service provides specialized care for women throughout all stages of life. We offer comprehensive treatment for pregnancy-related conditions, postpartum recovery, pelvic health, and more.",
    benefits: [
      "Improved pelvic floor function",
      "Better pregnancy and postpartum recovery",
      "Enhanced core strength",
      "Reduced pain and discomfort",
      "Increased confidence in movement",
      "Better quality of life"
    ],
    approach: [
      "Pregnancy-related back and pelvic pain treatment",
      "Postpartum recovery and rehabilitation",
      "Pelvic floor dysfunction management",
      "Incontinence management",
      "Osteoporosis prevention and management",
      "Post-gynecological surgery rehabilitation"
    ]
  };

  return <ServiceLayout {...serviceData} />;
};

export default WomensHealth; 